import Icon, {ilsNoError} from "../Icon";
import React from "react";
import '../../../assets/sass/components/feedback/no-error.scss';

const NoError = props => {
    const text = props.text || "Sorry, Something is broken";
    const details = props.details || "We unable to retrieve data at this moment, please try again or refresh the browser.";

    return (
        <div className="feedback-no-error">
            <Icon className="feedback-no-error--icon" svg={ilsNoError}/>
            <span className="feedback-no-error--text"> {text} </span>
            <span className="feedback-no-error--details"> {details} </span>
        </div>
    );
};

const WithWrapper = (component) => <div className="w-100 h-100 d-flex justify-content-center align-items-center"> {component} </div>;

const E404Text = "Sorry, Page not found";
const E404Details = "We unable to retrieve data at this moment, please try again or refresh the browser.";
NoError.E404 = props => <NoError text={props.text || E404Text} details={props.details || E404Details}/>

NoError.WithWrapper = props => WithWrapper(<NoError {...props}/>);

NoError.E404WithWrapper = props => WithWrapper(<NoError.E404 {...props}/>);


export default NoError;
